// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Mr-z","giftOrPromoSelector":"Nr-z","disabled":"Or-z","subTitle":"Pr-z","selectShipAddressMessage":"Qr-z","changePayment":"Rr-z"};